import { maxBSYear as e, minBSYear as t } from "../constants/calendar-date.js";
import "dayjs";
// src/design/forms/datepicker/calendar-engine/utilities/date-validations.ts
var n = (n) => {
	let r = t, i = e;
	if (n < r || n > i) throw RangeError(`BS year should be in range of ${r} to ${i}`);
}, r = (e) => {
	if (e < 1 || e > 12) throw RangeError("BS month should be in range of 1 to 12");
};
export { r as validateBsMonth, n as validateBsYear };

//# sourceMappingURL=date-validations.js.map